module.exports = __webpack_public_path__ + "static/media/chinese_01.6e54dbae.jpg";